export const SEARCH = 'search';
export const SHOW_NAV = 'showNav';
export const NAV_CODE = 'navCode';
export const FIX_HEADER = 'fixHeader';
